import React from 'react';
import { Box, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const Footer: React.FC = () => {
  const { t } = useTranslation('components', { keyPrefix: 'footer' });
  return (
    <Box
      component='footer'
      sx={{
        padding: '12px 0 24px 0',
      }}
    >
      <Box
        sx={{
          color: '#666',
          fontSize: '14px',
        }}
      >
        {t('powered_by')}
        {' '}
        <Link
          href='https://www.creditpulse.com'
          sx={{
            color: '#4b685c',
            textDecoration: 'underline',
          }}
          target='_blank'
        >
          Credit Pulse
        </Link>
      </Box>
    </Box>
  );
};
